// extracted by mini-css-extract-plugin
export default {"root":"ProfileHeading_root__Hu1le","avatar":"ProfileHeading_avatar__dBGaP","name":"ProfileHeading_name__Ra3Bj","bio":"ProfileHeading_bio__Fkyv-"};